import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
ReactGA.initialize(TRACKING_ID, {
  legacyDimensionMetric: false,
  gtagOptions: { send_page_view: true },
});

const RouteChangeTracker = () => {
  const location = useLocation();
  useEffect(
    function () {
      const path = location.pathname + location.search;
      ReactGA.send({ hitType: "pageview", page: path });
    },
    [location]
  );
  return "";
};
export default RouteChangeTracker;
